"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebMessenger = void 0;
var _config = require("@ori-appshell/config");
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _script = _interopRequireDefault(require("next/script"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const SPA_ID = 'web-messenger';
const WebMessenger = () => {
  const {
    tenant,
    environment
  } = (0, _environment.useEnvironment)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    globalApiUrl,
    graphQlNetUrl: graphqlNetUrl,
    identityUrl,
    kpiApiUrl,
    staticApiUrl,
    clientAppsUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'graphQlNet', 'identity', 'staticApi', 'clientApps']);
  const entryFile = (0, _config.createSpaEntryfileUrl)(SPA_ID, environment, clientAppsUrl);
  const spaConfig = (0, _react.useMemo)(() => ({
    currentLanguage: language,
    customerId,
    globalApiUrl,
    graphqlNetUrl,
    identityUrl,
    kpiApiUrl,
    staticApiUrl,
    tenant
  }), [customerId, identityUrl, graphqlNetUrl, globalApiUrl, kpiApiUrl, language, staticApiUrl, tenant]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: `${SPA_ID}-root`,
      "data-app-url": `${clientAppsUrl}/${SPA_ID}/`,
      "data-config": JSON.stringify(spaConfig)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_script.default, {
      id: SPA_ID,
      crossOrigin: "anonymous",
      strategy: "afterInteractive",
      src: entryFile
    })]
  });
};
exports.WebMessenger = WebMessenger;
